import React, { useState } from 'react';
import { glossaryTerms } from '../data/mockData';
import { Input } from '../components/ui/input';
import { Search, BookOpen } from 'lucide-react';

const GlossarioPage = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTerms = glossaryTerms.filter(t =>
    t.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
    t.definition.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          GLOSSARIO
        </h1>
        <div className="w-20 h-1 mx-auto mb-4" style={{ backgroundColor: 'var(--tp-red)' }} />
        <p className="text-center text-gray-400 mb-8 sm:mb-10 max-w-xl mx-auto text-sm sm:text-base">
          Tutti i termini che devi conoscere nel mondo del freestyle e dell'Hip Hop.
        </p>

        {/* Search */}
        <div className="relative mb-10">
          <Search size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
          <Input
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="pl-10 bg-gray-900 border-gray-700 text-white placeholder:text-gray-600 focus:border-red-500"
            placeholder="Cerca un termine..."
          />
        </div>

        {/* Terms List */}
        <div className="space-y-4">
          {filteredTerms.map((item, i) => (
            <div key={i} className="rounded-lg p-5 border border-gray-800 hover:border-red-600 transition-all duration-300 group"
              style={{ backgroundColor: 'var(--tp-dark)' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(0)'; }}>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'var(--tp-red)' }}>
                  <BookOpen size={18} className="text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>
                    {item.term}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{item.definition}</p>
                </div>
              </div>
            </div>
          ))}
          {filteredTerms.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500">Nessun termine trovato per "{searchTerm}"</p>
            </div>
          )}
        </div>

        {/* Stats */}
        <div className="mt-12 text-center text-gray-500 text-sm">
          {glossaryTerms.length} termini nel glossario
        </div>
      </div>
    </div>
  );
};

export default GlossarioPage;
